export const allLeaveRequestConstans = {
    GET_REQUEST_LIST_SUCCESS: "GET_REQUEST_LIST_SUCCESS",
    GET_REQUEST_LIST: "GET_REQUEST_LIST",
    GET_REQUEST_LIST_PAGE: "GET_REQUEST_LIST_PAGE",
};

export const employeeStatus = {
    0: "working",
    1: "nonWorking",
};
